module.exports = __webpack_public_path__ + "static/media/loading.09cfe256.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/loading.svg
// module id = 2130
// module chunks = 0